const cmsSharedConstantsAr = {
  cmsErrorTitleEN: 'الرجاء ادخال العنوان الإنجليزي',
  cmsErrorTitleAR: 'الرجاء ادخال العنوان العربي',
  cmsErrorContentEN: 'الرجاء ادخال المحتوى الإنجليزي',
  cmsErrorContentAR: 'الرجاء ادخال المحتوى العربي',
  cmsErrorName: 'الرجاء ادخال الاسم',
  cmsFormInputLanguage: 'لغة الإدخال',
  cmsFormEnglish: 'الإنجليزية',
  cmsFormArabic: 'العربية',
  cmsFormBiLingual: 'الإنجليزية والعربية',
  cmsFormTitleEn: 'العنوان بالإنجليزية',
  cmsFormTitleAr: 'العنوان بالعربية',
  cmsFormSaveButton: 'حفظ',
  cmsFormEditButton: 'تعديل',
  cmsFormDeleteButton: 'حذف',
};

export default cmsSharedConstantsAr;
